/**
 * Converts legacy `colorStyles` format into the new `colors` format.
 * @param {Object} colorStyles - The old colorStyles object from designSettings.
 * @returns {Object} - New colors object compatible with color palette system.
 */
export function convertColorStylesToColors(colorStyles) {
    if (!colorStyles || typeof colorStyles !== 'object') {
        console.warn("Invalid colorStyles object provided for conversion.");
        return null;
    }

    return {
        heroTitle: {
            ...colorStyles.heroTitle,
            text: {
                idle: {
                    color: colorStyles.heroTitle.color,
                    paletteColorIndex: colorStyles.heroTitle.paletteColorIndex
                }
            }
        },
        heroSubtitle: {
            ...colorStyles.heroSubtitle,
            text: {
                idle: {
                    color: colorStyles.heroSubtitle.color,
                    paletteColorIndex: colorStyles.heroSubtitle.paletteColorIndex
                }
            }
        },
        heroParagraph: {
            ...colorStyles.heroParagraph,
            text: {
                idle: {
                    color: colorStyles.heroParagraph.color,
                    paletteColorIndex: colorStyles.heroParagraph.paletteColorIndex
                }
            }
        },
        h1: {
            ...colorStyles.h1,
            text: {
                idle: {
                    color: colorStyles.h1.color,
                    paletteColorIndex: colorStyles.h1.paletteColorIndex
                }
            }
        },
        h2: {
            ...colorStyles.h2,
            text: {
                idle: {
                    color: colorStyles.h2.color,
                    paletteColorIndex: colorStyles.h2.paletteColorIndex
                }
            }
        },
        h3: {
            ...colorStyles.h3,
            text: {
                idle: {
                    color: colorStyles.h3.color,
                    paletteColorIndex: colorStyles.h3.paletteColorIndex
                }
            }
        },
        h4: {
            ...colorStyles.h4,
            text: {
                idle: {
                    color: colorStyles.h4.color,
                    paletteColorIndex: colorStyles.h4.paletteColorIndex
                }
            }
        },
        p1: {
            ...colorStyles.p1,
            text: {
                idle: {
                    color: colorStyles.p1.color,
                    paletteColorIndex: colorStyles.p1.paletteColorIndex
                }
            }
        },
        p2: {
            ...colorStyles.p2,
            text: {
                idle: {
                    color: colorStyles.p2.color,
                    paletteColorIndex: colorStyles.p2.paletteColorIndex
                }
            }
        },
        projectTitle: {
            ...colorStyles.projectTitle,
            text: {
                idle: {
                    color: colorStyles.projectTitle.color,
                    paletteColorIndex: colorStyles.projectTitle.paletteColorIndex
                }
            }
        },
        projectSubtitle: {
            ...colorStyles.projectSubtitle,
            text: {
                idle: {
                    color: colorStyles.projectSubtitle.color,
                    paletteColorIndex: colorStyles.projectSubtitle.paletteColorIndex
                }
            }
        },
        background: {
            ...colorStyles.background,
            fill: {
                idle: {
                    color: colorStyles.background.color,
                    paletteColorIndex: colorStyles.background.paletteColorIndex
                }
            }
        },
        sidebarBackground: {
            ...colorStyles.sidebarBackground,
            fill: {
                idle: {
                    color: colorStyles.sidebarBackground.color,
                    paletteColorIndex: colorStyles.sidebarBackground.paletteColorIndex
                }
            }
        },
        card: {
            ...colorStyles.card,
            fill: {
                idle: {
                    color: colorStyles.cardFill?.color,
                    paletteColorIndex: colorStyles.cardFill?.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.cardOutline?.color,
                    paletteColorIndex: colorStyles.cardOutline?.paletteColorIndex
                }
            },
        },
        dividerLine: {
            ...colorStyles.dividerLine,
            fill: {
                idle: {
                    color: colorStyles.dividerLine.color,
                    paletteColorIndex: colorStyles.dividerLine.paletteColorIndex
                }
            }
        },
        hyperLink: {
            ...colorStyles.hyperLink,
            text: {
                idle: {
                    color: colorStyles.hyperLink.color,
                    paletteColorIndex: colorStyles.hyperLink.paletteColorIndex
                }
            }
        },
        navigation: {
            ...colorStyles.navigation,
            text: {
                idle: {
                    color: colorStyles.navigation.color,
                    paletteColorIndex: colorStyles.navigation.paletteColorIndex
                },
                hover: {
                    color: colorStyles.navigationHover?.color,
                    paletteColorIndex: colorStyles.navigationHover?.paletteColorIndex
                }
            },
            fill: {
                idle: {
                    color: colorStyles.navigationFill?.color,
                    paletteColorIndex: colorStyles.navigationFill?.paletteColorIndex
                },
                hover: {
                    color: colorStyles.navigationFillHover?.color,
                    paletteColorIndex: colorStyles.navigationFillHover?.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.navigationOutline ? colorStyles.navigationOutline.color : colorStyles.navigation.color,
                    paletteColorIndex: colorStyles.navigationOutline ? colorStyles.navigationOutline.paletteColorIndex : colorStyles.navigation.paletteColorIndex
                },
                hover: {
                    color: colorStyles.navigationOutlineHover ? colorStyles.navigationOutlineHover.color : colorStyles.navigationHover?.color,
                    paletteColorIndex: colorStyles.navigationOutlineHover ? colorStyles.navigationOutlineHover.paletteColorIndex : colorStyles.navigationHover?.paletteColorIndex
                }
            },
        },
        button: {
            ...colorStyles.buttonText,
            text: {
                idle: {
                    color: colorStyles.buttonText.color,
                    paletteColorIndex: colorStyles.buttonText.paletteColorIndex
                },
                hover: {
                    color: colorStyles.buttonTextHover?.color,
                    paletteColorIndex: colorStyles.buttonTextHover?.paletteColorIndex
                }
            },
            fill: {
                idle: {
                    color: colorStyles.buttonFill?.color,
                    paletteColorIndex: colorStyles.buttonFill?.paletteColorIndex
                },
                hover: {
                    color: colorStyles.buttonFillHover?.color,
                    paletteColorIndex: colorStyles.buttonFillHover?.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.buttonOutline?.color,
                    paletteColorIndex: colorStyles.buttonOutline?.paletteColorIndex
                },
                hover: {
                    color: colorStyles.buttonOutlineHover?.color,
                    paletteColorIndex: colorStyles.buttonOutlineHover?.paletteColorIndex
                }
            },
        },
        label: {
            text: {
                idle: {
                    color: colorStyles.labelText?.color,
                    paletteColorIndex: colorStyles.labelText?.paletteColorIndex
                }
            },
            fill: {
                idle: {
                    color: colorStyles.labelFill?.color,
                    paletteColorIndex: colorStyles.labelFill?.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.labelOutline?.color,
                    paletteColorIndex: colorStyles.labelOutline?.paletteColorIndex
                }
            },
        },
        contactForm: {
            ...colorStyles.contactFormText,
            text: {
                idle: {
                    color: colorStyles.contactFormText ? colorStyles.contactFormText.color : colorStyles.p1.color,
                    paletteColorIndex: colorStyles.contactFormText ? colorStyles.contactFormText.paletteColorIndex : colorStyles.p1.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.contactFormOutline ? colorStyles.contactFormOutline.color : "#E2E3E8",
                    paletteColorIndex: colorStyles.contactFormOutline?.paletteColorIndex
                }
            },
        },
        processStep: {
            ...colorStyles.processText,
            text: {
                idle: {
                    color: colorStyles.processText ? colorStyles.processText?.color : colorStyles.h1.color, /// ????????
                    paletteColorIndex: colorStyles.processText ? colorStyles.processText?.paletteColorIndex : colorStyles.h1.paletteColorIndex /// ????????
                },
                active: {
                    color: colorStyles.processTextActive ? colorStyles.processTextActive.color : colorStyles.h1.color,
                    paletteColorIndex: colorStyles.processTextActive ? colorStyles.processTextActive.paletteColorIndex : colorStyles.h1.paletteColorIndex
                }
            },
            fill: {
                active: {
                    color: colorStyles.processFillActive ? colorStyles.processFillActive.color : colorStyles.h1.color,
                    paletteColorIndex: colorStyles.processFillActive ? colorStyles.processFillActive?.paletteColorIndex : colorStyles.h1.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.processOutline ? colorStyles.processOutline.color : colorStyles.h1.color,
                    paletteColorIndex: colorStyles.processOutline ? colorStyles.processOutline.paletteColorIndex : colorStyles.h1.paletteColorIndex
                }
            },
        },
        socialIcon: {
            ...colorStyles.socialIconText,
            text: {
                idle: {
                    color: colorStyles.socialIconText ? colorStyles.socialIconText.color : colorStyles.navigation.color,
                    paletteColorIndex: colorStyles.socialIconText ? colorStyles.socialIconText.paletteColorIndex : colorStyles.navigation.paletteColorIndex
                },
                hover: {
                    color: colorStyles.socialIconTextHover ? colorStyles.socialIconTextHover.color : colorStyles.navigationHover.color,
                    paletteColorIndex: colorStyles.socialIconTextHover ? colorStyles.socialIconTextHover.paletteColorIndex : colorStyles.navigationHover.paletteColorIndex
                }
            },
            fill: {
                idle: {
                    color: colorStyles.socialIconFill?.color,
                    paletteColorIndex: colorStyles.socialIconFill?.paletteColorIndex
                },
                hover: {
                    color: colorStyles.socialIconFillHover?.color,
                    paletteColorIndex: colorStyles.socialIconFillHover?.paletteColorIndex
                }
            },
            outline: {
                idle: {
                    color: colorStyles.socialIconOutline ? colorStyles.socialIconOutline?.color : colorStyles.navigation.color,
                    paletteColorIndex: colorStyles.socialIconOutline ? colorStyles.socialIconOutline?.paletteColorIndex : colorStyles.navigation.paletteColorIndex
                },
                hover: {
                    color: colorStyles.socialIconOutlineHover ? colorStyles.socialIconOutlineHover?.color : colorStyles.navigationHover.color,
                    paletteColorIndex: colorStyles.socialIconOutlineHover ? colorStyles.socialIconOutlineHover?.paletteColorIndex : colorStyles.navigationHover.paletteColorIndex
                }
            },
        }
    }
}
